/* 🤖 this file was generated by svg-to-ts */
export const matIconDesk: {
  name: 'desk';
  data: string;
} = {
  name: 'desk',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 6v12h2V8h10v10h2v-2h4v2h2V6H2zm18 2v2h-4V8h4zm-4 6v-2h4v2h-4z"/></svg>`
};
